<template>
  <!-- 折线图 -->
  <div :id="lineChartInfo.nodeId"></div>
</template>

<script>
export default {
  name: "LineChart",
  props:["lineChartInfo"],
  data(){
    return {
    //   lineChartInfo:{
    //       nodeId:'fansNum',//节点
    //       data: [41.69, 41.7, 41.8, 41.75, 41.75, 41.85, 41.68, 41.75, 41.75, 41.85, 41.68],//数据
    //       smooth:true,//平滑
    //       xAxisData:['08-05', '08-06', '08-07', '08-08', '08-09', '08-10', '08-11', '08-12', '08-12', '08-12', '08-19'],
    //       min:41.65, //y轴的最小值
    //       max:41.9, //y轴最大值
    //       interval:0.05, //值之间的间隔
    //       yAxisName: '分数',
    //       tooltipName:'粉丝总量',
    //       unit:'w'
    //   }
    }
  },
  computed:{

  },
  methods:{
    lineChart(lineChartInfo){
      // console.log(lineChartInfo)
      // console.log('lineChartInfo.data',lineChartInfo)
      this.$echarts.dispose(document.getElementById(lineChartInfo.nodeId));
      var myChart = this.$echarts.init(document.getElementById(lineChartInfo.nodeId));
      myChart.setOption( {
        grid:{
          x:50,
          y:56,
          x2:20,
          y2:20
        },
        tooltip : {
          trigger: 'axis',
          // formatter: '{b0}<br/>'+lineChartInfo.tooltipName+'：{c0}'+lineChartInfo.unit+'',
          formatter: function (params) {
            let vals=params[0].data
            if(lineChartInfo.unit==="%"){
              vals=vals+"%"
            }
            if(lineChartInfo.unit2&&lineChartInfo.unit2==='￥'){
              vals=vals+lineChartInfo.unit
            }else{
              if(vals>=10000){
                vals=(vals/10000).toFixed(2)+'w'+lineChartInfo.unit
              }
            }
            if(lineChartInfo.unit2){
              vals=lineChartInfo.unit2+vals
            }
            return '<div>'+params[0].name+'</div><div>'+ params[0].seriesName+' : '+ vals+'</div>'
            // return '<div>观看时长：'+params[0].name+'</div><div>'+ params[0].marker+' '+ params[0].seriesName+' '+ params[0].data+'</div>'
          },
          confine: true,//浮窗不超出屏幕范围
          textStyle: {
            fontSize: 12,
            color: '#333'
          },
          backgroundColor: '#fff',
          borderRadius: 4,
          axisPointer : {            // 坐标轴指示器，坐标轴触发有效
            type : 'line',         // 默认为直线，可选为：'line' | 'shadow'
            lineStyle : {          // 直线指示器样式设置
                color: '#333',
                width: 0.2,
                type: 'solid'
            },
            z: 2,//竖线在圆圈后面
          },
          extraCssText:'box-shadow:0 0 18px rgba(0,0,0,0.2)'//提示框阴影
        },
        xAxis: {
            type: 'category',
            data: lineChartInfo.xAxisData,
            axisLine:{
                show:true,//去除y轴线
                lineStyle: {
                    color: '#eee',
                    width: 0.8, //这里是为了突出显示加上的
                }
            },
            axisLabel: {
                  textStyle: {
                      color:  '#999' , //坐标字值得具体的颜色
                  }
              },
            axisTick:{
                show:false//去除y轴刻度
            },
        },
        yAxis: {
            type: 'value',
            scale:true,
            name: lineChartInfo.yAxisName,
            // min:lineChartInfo.min, //y轴的最小值
            // max:lineChartInfo.max, //y轴最大值
            // interval:lineChartInfo.interval, //值之间的间隔
            nameTextStyle:{
              padding:[0,0,10,-40],
              color:"#999",
            },
            splitLine:{
                show: true,
                lineStyle:{
                    type:'dashed',
                    color:"#ddd",
                    width:0.6
                },
            },//去除网格线
            axisLabel:{
              // formatter: '{value}'+lineChartInfo.unit+'',
              formatter:function (value) {
                var txt=value
                if(value>=10000){
                  txt=value/10000+'w'
                }
                return txt
              },
                textStyle: {
                  color: '#999', //坐标值得具体的颜色
                }
            },
            axisLine:{
                show:false//去除y轴线
            },
            axisTick:{
                show:false//去除y轴刻度
            },
        },
        //折线图区域颜色渐变
        series: [{
          name:lineChartInfo.yAxisName,
          hoverAnimation: false,
          symbolSize: 8,
          showSymbol: false,
          color: '#3f90fd',
          areaStyle: {
            color: '#ebf6ff',//区域颜色
          },
          data: lineChartInfo.data,
          type: 'line',
          smooth: lineChartInfo.smooth,//平滑
          itemStyle: { //折线样式
            emphasis: {
              color: '#3f90fd',
              borderColor:'#fff',
              borderWidth:'3',
              shadowColor:'#3f90fd',
              shadowBlur: 2
            },
          },//线条样式

        }],
      })
    },

  },
  components:{

  },
  watch:{

  },
  mounted() {
    this.lineChart(this.lineChartInfo)
  }
}
</script>

<style scoped>


</style>